<template>
  <div>
    <px-view-header title="Locais de coleta" :breadcrumbs="breadcrumbs">
      <template v-slot:after>
        <px-ajuda-icon :link="linkAjuda"/>
      </template>
    </px-view-header>
    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <div v-if="!loading && empresa">
      <px-lista-selecao-estados class="mt-2"
                                :initial-value="initialLocais"
                                v-model="empresa.locaisColeta"
                                :max-select="27"/>
      <v-row>
        <v-col cols="12">
          <v-btn color="primary" :loading="loadingSave" @click="save">
            Salvar
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { cloneDeep, find } from 'lodash';
import TransportadoraService from '@/api/transportador-service';
import PxListaSelecaoEstados from '@/modules/criar-conta/locais-atuacao/lista-selecao-estado/PxListaSelecaoEstados.vue';
import { locaisColeta } from '@/api/ajuda-mapper';

export default {
  data() {
    return {
      loading: false,
      loadingSave: false,
      empresa: null,
      initialLocais: [],
      linkAjuda: locaisColeta,
      breadcrumbs: [
        { text: 'Empresa' },
        { text: 'Locais de coleta' },
      ],
    };
  },
  methods: {
    buildPayload() {
      const transportador = cloneDeep(this.empresa);
      transportador.locaisColeta = transportador.locaisColeta
        .map((local) => {
          const initialLocal = find(this.initialLocais, (a) => a.estado.id === local.id);
          let initalId;
          if (initialLocal) {
            initalId = initialLocal.id;
          }
          return {
            id: initalId,
            estado: {
              id: local.id,
            },
          };
        });
      return transportador;
    },
    save() {
      this.loadingSave = true;
      TransportadoraService.update(this.empresa.id, this.buildPayload())
        .then(() => {
          this.$toast('Locais de coleta atuailizados', { color: 'success' });
          this.getTransportadora();
        })
        .finally(() => {
          this.loadingSave = false;
        });
    },
    getTransportadora() {
      this.loading = true;
      TransportadoraService.get()
        .then((response) => {
          [this.empresa] = response.data;
          return TransportadoraService.getBy(this.empresa.id)
            .then(({ data }) => {
              this.empresa = data;
              this.initialLocais = cloneDeep(this.empresa.locaisColeta);
            });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getTransportadora();
  },
  components: { PxListaSelecaoEstados },
};
</script>
